<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 ContractCaseSettings"
                    :data="contract_tab"
                    :query-param="{id:$route.params.id}"
                    activeKey="email_settings"
                    arrows >
                    <template slot="gofixTab:email_settings">
                        <gofix-tab
                            class="mt-3 contractPropertyChildTab"
                            classTabContent="border-none box-shadow-none"
                            :data="tabDataChild"
                            showFullTab>
                            <template slot="gofixTab:email_status">
                                <EmailStatus />
                            </template>
                            <template slot="gofixTab:default_filters">
                                <DefaultFilter />
                            </template>
                           
                        </gofix-tab>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    import DefaultFilter from './defaultfilter.vue'
    import EmailStatus from './email-status.vue'
    export default {
        name: 'contract-case-settings',
        components: {
            DefaultFilter,
            EmailStatus
        },
        data () {
            return {
                contract_tab: tabData.client_contract,
                tabDataChild:[
                    {
                        key: "email_status",
                        title: "Email Status",
                        active: true
                    },
                    {
                        key: "default_filters",
                        title: "Default Filters",
                        active: false
                    },
                ],
            }
        },
        created() {},
        methods:{}
    }
</script>
